import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';
import { HelpIcon, HomeIcon, LogoutIcon, ProfileIcon } from './Icons';
export const MobileMenu = (props) => {
    const { mobileMenuId, mobileMenuAnchorEl, onMobileMenuClose, home, help, currentUser, logout } = props;
    return (React.createElement(Menu, { anchorEl: mobileMenuAnchorEl, anchorOrigin: { vertical: 'top', horizontal: 'right' }, id: mobileMenuId, keepMounted: true, transformOrigin: { vertical: 'top', horizontal: 'right' }, open: Boolean(mobileMenuAnchorEl), onClose: onMobileMenuClose },
        !!home ? (React.createElement(MenuItem, null,
            React.createElement(HomeIcon, { onClick: home }))) : null,
        !!help ? (React.createElement(MenuItem, null,
            React.createElement(HelpIcon, { onClick: help }))) : null,
        !!currentUser ? (React.createElement(MenuItem, null,
            React.createElement(ProfileIcon, { onClick: currentUser }))) : null,
        !!logout ? (React.createElement(MenuItem, null,
            React.createElement(LogoutIcon, { onClick: logout }))) : null));
};
//# sourceMappingURL=MobileMenu.js.map